import { useEffect, useState } from 'react'
import { SEARCH_OPERATOR } from '../../constants.js'
import { Input } from 'reactstrap'
import PubSub from 'pubsub-js'

export default function SearchFormNotPopup(props) {
  const { index, initialOperatorId, onChangeFunction, defaultValue } = props
  console.log('SearchFormNotPopup rendered', props)

  const [operatorId, setOperatorId] = useState(initialOperatorId)

  useEffect(() => {
    function handleOperatorChangedEvent(msg, data) {
      console.log(`EVENT RECEIVED (SearchFormNotPopup): ${msg}`, data)
      setOperatorId(data)
    }

    const token = PubSub.subscribe(`OPERATOR POPUP CHANGED ${index}`, handleOperatorChangedEvent)
    return function cleanup() {
      PubSub.unsubscribe(token)
    }
  })


  let verb = 'Is'
  if (parseInt(operatorId) === SEARCH_OPERATOR.contains) {
    verb = 'Does'
  }
  return (
    <Input index={index} type="select" name="notOperator" bsSize="sm" data-cy="search-form-not" onChange={onChangeFunction} defaultValue={defaultValue} >
      <option key={1} value="N">{verb}</option>
      <option key={2} value="Y">{verb} Not</option>
    </Input>
  )
}